/* eslint-disable */
import axios from 'axios'
import mapBoxGl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { getRange } from './mapServe.umd.min.js'
import * as turf from '@turf/turf'
import Bus from '@/config/Bus'

export function request(config) {
  // 创建axios实例
  const instance = axios.create({
    baseURL: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap',
  })
  return instance(config)
}

let hoveredStateId = {
  工业企业: null,
  工业园区: null,
  污水处理厂: null,
  农贸市场: null,
  餐饮企业: null,
  畜牧养殖: null,
  水产养殖: null,
  沿河排口: null,
}

let initialObject = {
  //地图初始参数
  center: [105.918014, 29.168635],
  zoom: 10.5,
  pitch: 50,
  bearing: 0,
  speed: 0.2,
}

let map = undefined
let _that
let riverline
request({
  url: '/yczhhz/json/riverline-new.json',
}).then((res) => {
  riverline = res.data
})
request({
  url: '/yczhhz/json/乡镇.json',
}).then((res) => {
  xzData = res.data
})

class mapService {
  constructor(accessToken) {
    this.map = undefined
  }
  async initMap(object, token, that) {
    let _this = this
    that ? (_that = that) : ''
    mapBoxGl.accessToken = token
    this.map = new mapBoxGl.Map(object)
    // this.map.loadImage('https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/图标/b2-right.png', (error, image) => {
    //   if (error) throw error
    //   this.map.addImage('b2-right.png', image)
    // })
    // this.map.loadImage(require('@/assets/img/map/污水处理厂.png'), (error, image) => {
    //   if (error) throw error
    //   this.map.addImage('污水处理厂', image)
    // })
    // this.map.loadImage(require('@/assets/img/map/UAV.png'), (error, image) => {
    //   if (error) throw error
    //   this.map.addImage('UAV', image)
    // })
    // this.map.loadImage(require('@/assets/img/riverDetails.png'), (error, image) => {
    //   if (error) throw error
    //   this.map.addImage('point1', image)
    // })
    // setTimeout(() => {
    //     this.map.loadImage(canvas.toDataURL("image/png"), (error, image) => {
    //         if (error) throw error;
    //         this.map.addImage("xxxx", image);
    //     });
    // }, 2000);

    this.map.on('mousemove', '工业企业', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.工业企业) {
          _this.map.setFeatureState(
            { source: '工业企业', id: hoveredStateId.工业企业 },
            { hover: false }
          )
        }
        hoveredStateId.工业企业 = e.features[0].id
        _this.map.setFeatureState(
          { source: '工业企业', id: hoveredStateId.工业企业 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '工业园区', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.工业园区) {
          _this.map.setFeatureState(
            { source: '工业园区', id: hoveredStateId.工业园区 },
            { hover: false }
          )
        }
        hoveredStateId.工业园区 = e.features[0].id
        _this.map.setFeatureState(
          { source: '工业园区', id: hoveredStateId.工业园区 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '污水处理厂', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.污水处理厂) {
          _this.map.setFeatureState(
            { source: '污水处理厂', id: hoveredStateId.污水处理厂 },
            { hover: false }
          )
        }
        hoveredStateId.污水处理厂 = e.features[0].id
        _this.map.setFeatureState(
          { source: '污水处理厂', id: hoveredStateId.污水处理厂 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '农贸市场', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.农贸市场) {
          _this.map.setFeatureState(
            { source: '农贸市场', id: hoveredStateId.农贸市场 },
            { hover: false }
          )
        }
        hoveredStateId.农贸市场 = e.features[0].id
        _this.map.setFeatureState(
          { source: '农贸市场', id: hoveredStateId.农贸市场 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '餐饮企业', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.餐饮企业) {
          _this.map.setFeatureState(
            { source: '餐饮企业', id: hoveredStateId.餐饮企业 },
            { hover: false }
          )
        }
        hoveredStateId.餐饮企业 = e.features[0].id
        _this.map.setFeatureState(
          { source: '餐饮企业', id: hoveredStateId.餐饮企业 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '畜牧养殖', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.畜牧养殖) {
          _this.map.setFeatureState(
            { source: '畜牧养殖', id: hoveredStateId.畜牧养殖 },
            { hover: false }
          )
        }
        hoveredStateId.畜牧养殖 = e.features[0].id
        _this.map.setFeatureState(
          { source: '畜牧养殖', id: hoveredStateId.畜牧养殖 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '水产养殖', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.水产养殖) {
          _this.map.setFeatureState(
            { source: '水产养殖', id: hoveredStateId.水产养殖 },
            { hover: false }
          )
        }
        hoveredStateId.水产养殖 = e.features[0].id
        _this.map.setFeatureState(
          { source: '水产养殖', id: hoveredStateId.水产养殖 },
          { hover: true }
        )
      }
    })
    this.map.on('mousemove', '沿河排口', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId.沿河排口) {
          _this.map.setFeatureState(
            { source: '沿河排口', id: hoveredStateId.沿河排口 },
            { hover: false }
          )
        }
        hoveredStateId.沿河排口 = e.features[0].id
        _this.map.setFeatureState(
          { source: '沿河排口', id: hoveredStateId.沿河排口 },
          { hover: true }
        )
      }
    })

    // When the mouse leaves the state-fill layer, update the feature state of the
    // previously hovered feature.
    this.map.on('mouseleave', '工业企业', function () {
      if (hoveredStateId.工业企业) {
        _this.map.setFeatureState(
          { source: '工业企业', id: hoveredStateId.工业企业 },
          { hover: false }
        )
      }
      hoveredStateId.工业企业 = null
    })
    this.map.on('mouseleave', '工业园区', function () {
      if (hoveredStateId.工业园区) {
        _this.map.setFeatureState(
          { source: '工业园区', id: hoveredStateId.工业园区 },
          { hover: false }
        )
      }
      hoveredStateId.工业园区 = null
    })
    this.map.on('mouseleave', '污水处理厂', function () {
      if (hoveredStateId.污水处理厂) {
        _this.map.setFeatureState(
          { source: '污水处理厂', id: hoveredStateId.污水处理厂 },
          { hover: false }
        )
      }
      hoveredStateId.污水处理厂 = null
    })
    this.map.on('mouseleave', '农贸市场', function () {
      if (hoveredStateId.农贸市场) {
        _this.map.setFeatureState(
          { source: '农贸市场', id: hoveredStateId.农贸市场 },
          { hover: false }
        )
      }
      hoveredStateId.农贸市场 = null
    })
    this.map.on('mouseleave', '餐饮企业', function () {
      if (hoveredStateId.餐饮企业) {
        _this.map.setFeatureState(
          { source: '餐饮企业', id: hoveredStateId.餐饮企业 },
          { hover: false }
        )
      }
      hoveredStateId.餐饮企业 = null
    })
    this.map.on('mouseleave', '畜牧养殖', function () {
      if (hoveredStateId.畜牧养殖) {
        _this.map.setFeatureState(
          { source: '畜牧养殖', id: hoveredStateId.畜牧养殖 },
          { hover: false }
        )
      }
      hoveredStateId.畜牧养殖 = null
    })
    this.map.on('mouseleave', '水产养殖', function () {
      if (hoveredStateId.水产养殖) {
        _this.map.setFeatureState(
          { source: '水产养殖', id: hoveredStateId.水产养殖 },
          { hover: false }
        )
      }
      hoveredStateId.水产养殖 = null
    })
    this.map.on('mouseleave', '沿河排口', function () {
      if (hoveredStateId.沿河排口) {
        _this.map.setFeatureState(
          { source: '沿河排口', id: hoveredStateId.沿河排口 },
          { hover: false }
        )
      }
      hoveredStateId.沿河排口 = null
    })

    this.map.on('click', (e) => {
      this._clickMap(e)
    })
  }

  _clickMap(e) {
    let features = this.map.queryRenderedFeatures(e.point)
    for (let i = 0; i < features.length; i++) {
      if (features[i].layer.type === 'symbol') {
        console.log(features[i].properties)
        Bus.emit('mapClick2', {
          data: features[i].properties,
          modalType: features[i].properties.modalType,
        })
        // _that.mapClick && _that.mapClick(features[i])
        break
      }
    }
  }

  //绘制轨迹
  drawTrajectory(id, coordinates, lineColor, lineWidth, zoom) {
    //图层ID，坐标，线颜色(默认 #ffee00)，线宽(默认 8)
    this.map.addLayer(
      {
        id: id,
        type: 'line',
        source: {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                geometry: {
                  type: 'LineString',
                  coordinates: coordinates,
                },
              },
            ],
          },
        },
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': lineColor ? lineColor : '#ffee00',
          'line-width': lineWidth ? lineWidth : 8,
        },
      },
      zoom
    )
  }

  //删除图层
  removeLayer(id) {
    this.map.getLayer(id) && this.map.removeLayer(id)
    this.map.getSource(id) && this.map.removeSource(id)
  }

  //给样式添加图像
  addImage(url, name) {
    this.map.loadImage(url, (error, image) => {
      if (error) throw error
      this.map.addImage(name, image)
    })
  }

  //添加图层（图层id，坐标，显示文字，图标名称， 图标大小， 图标锚点位置）
  addPointLayer(id, coordinates, title, icon, size = 1, iconAnchor = 'bottom') {
    this.map.addLayer({
      id: id,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: coordinates,
              },
            },
          ],
        },
      },
      layout: {
        'icon-image': icon,
        'text-field': title,
        'text-size': 20,
        'icon-size': size,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-offset': [0, -1.5],
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'icon-anchor': iconAnchor,
        'text-ignore-placement': true,
        'text-font': ['NotoCJK'],
      },
      paint: {
        'text-color': '#ffffff',
      },
    })
  }
  addPointsLayer(id, data, icon, size = 1, iconAnchor = 'bottom', textHover) {
    let features = []
    for (let i = 0; i < data.length; i++) {
      features.push({
        id: i,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: data[i].coordinates,
        },
        properties: data[i].properties,
      })
    }
    let textOpacity = 1
    if (textHover) {
      textOpacity = ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0]
    }
    this.map.addLayer({
      id: id,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: features,
        },
      },
      layout: {
        'icon-image': icon ? icon : ['get', 'icon'],
        'text-field': ['get', 'name'],
        'text-size': 12,
        'icon-size': size,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-offset': [0, -4.2],
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'icon-anchor': iconAnchor,
        'text-ignore-placement': true,
        'text-font': ['NotoCJK'],
      },
      paint: {
        'text-color': '#ffffff',
        'text-opacity': textOpacity,
      },
    })
  }
  addCirclePointsLayer(id, features, radius = 8, color = '#ff0000') {
    this.map.addLayer({
      id: id,
      type: 'circle',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: features,
        },
      },
      paint: {
        'circle-radius': radius,
        'circle-color': color,
      },
    })
  }

  // 获取辐射范围
  getBufferRange(point, rangeDistance, upstreamDistance, downstreamDistance) {
    // 点坐标，范围距离, 上游距离，下游距离
    console.log(point, rangeDistance, upstreamDistance, downstreamDistance)
    return getRange(riverline, point, upstreamDistance, downstreamDistance, rangeDistance)
  }

  //绘制范围
  drawBufferRange(data) {
    this.map.getLayer('buffer-range') && this.map.removeLayer('buffer-range')
    this.map.getLayer('buffer-range-line') && this.map.removeLayer('buffer-range-line')
    this.map.getSource('buffer-range') && this.map.removeSource('buffer-range')
    this.map.getSource('buffer-range-line') && this.map.removeSource('buffer-range-line')
    this.map.addLayer({
      id: 'buffer-range',
      type: 'fill',
      source: {
        type: 'geojson',
        data: data,
      },
      layout: {},
      paint: {
        'fill-color': '#088',
        'fill-opacity': 0.3,
      },
    })
    this.map.addLayer({
      id: 'buffer-range-line',
      type: 'line',
      source: {
        type: 'geojson',
        data: data,
      },
      layout: {},
      paint: {
        'line-color': '#088',
        'line-width': 2,
        'line-opacity': 0.8,
      },
    })
  }

  //定位(根据坐标)
  flyTo(options) {
    this.map.flyTo(options)
  }

  //根据范围定位
  fitBounds(bbox) {
    this.map.fitBounds(bbox, {
      padding: 40,
    })
  }

  // 显示图层
  showLayer(id) {
    this.map.setLayoutProperty(id, 'visibility', 'visible')
  }

  // 隐藏图层
  hideLayer(id) {
    this.map.setLayoutProperty(id, 'visibility', 'none')
  }

  //地图复位
  reset() {
    this.map.flyTo(initialObject)
  }
}

class MapService2 {
  constructor(accessToken) {
    this.map = undefined
  }
  async initMap(object, token, that) {
    that ? (_that = that) : ''
    mapBoxGl.accessToken = token
    this.map = new mapBoxGl.Map(object)

    this.map.on('click', (e) => {
      this._clickMap(e)
    })
  }

  _clickMap(e) {
    let features = this.map.queryRenderedFeatures(e.point)
    for (let i = 0; i < features.length; i++) {
      if (features[i].layer.type === 'symbol') {
        _that.mapClick && _that.mapClick(features[i])
        break
      }
    }
  }

  //绘制轨迹
  drawTrajectory(id, coordinates, lineColor, lineWidth) {
    //图层ID，坐标，线颜色(默认 #ffee00)，线宽(默认 8)
    this.map.addLayer({
      id: id,
      type: 'line',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: coordinates,
              },
            },
          ],
        },
      },
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': lineColor ? lineColor : '#ffee00',
        'line-width': lineWidth ? lineWidth : 8,
      },
    })
  }

  //删除图层
  removeLayer(id) {
    this.map.getLayer(id) && this.map.removeLayer(id)
    this.map.getSource(id) && this.map.removeSource(id)
  }

  //给样式添加图像
  addImage(url, name) {
    this.map.loadImage(url, (error, image) => {
      if (error) throw error
      this.map.addImage(name, image)
    })
  }

  //添加图层（图层id，坐标，显示文字，图标名称， 图标大小， 图标锚点位置）
  addPointLayer(id, coordinates, title, icon, size = 1, iconAnchor = 'bottom') {
    this.map.addLayer({
      id: id,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: coordinates,
              },
            },
          ],
        },
      },
      layout: {
        'icon-image': icon,
        'text-field': title,
        'text-size': 20,
        'icon-size': size,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-offset': [0, -1.5],
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'icon-anchor': iconAnchor,
        'text-ignore-placement': true,
        'text-font': ['NotoCJK'],
      },
      paint: {
        'text-color': '#ffffff',
      },
    })
  }
  addPointsLayer(id, data, icon, size = 1, iconAnchor = 'bottom') {
    let features = []
    for (let i = 0; i < data.length; i++) {
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: data[i].coordinates,
        },
        properties: data[i].properties,
      })
    }
    this.map.addLayer({
      id: id,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: features,
        },
      },
      layout: {
        'icon-image': icon ? icon : ['get', 'icon'],
        'text-field': ['get', 'name'],
        'text-size': 14,
        'icon-size': size,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-offset': [0, -4.5],
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'icon-anchor': iconAnchor,
        'text-ignore-placement': true,
        'text-font': ['NotoCJK'],
      },
      paint: {
        'text-color': '#ffffff',
      },
    })
  }
  addCirclePointsLayer(id, features, radius = 8, color = '#ff0000') {
    this.map.addLayer({
      id: id,
      type: 'circle',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: features,
        },
      },
      paint: {
        'circle-radius': radius,
        'circle-color': color,
      },
    })
  }

  // 获取辐射范围
  getBufferRange(point, rangeDistance, upstreamDistance, downstreamDistance) {
    // 点坐标，范围距离, 上游距离，下游距离
    console.log(point, rangeDistance, upstreamDistance, downstreamDistance)
    return getRange(riverline, point, upstreamDistance, downstreamDistance, rangeDistance)
  }

  //绘制范围
  drawBufferRange(data) {
    this.map.getLayer('buffer-range') && this.map.removeLayer('buffer-range')
    this.map.getLayer('buffer-range-line') && this.map.removeLayer('buffer-range-line')
    this.map.getSource('buffer-range') && this.map.removeSource('buffer-range')
    this.map.getSource('buffer-range-line') && this.map.removeSource('buffer-range-line')
    this.map.addLayer({
      id: 'buffer-range',
      type: 'fill',
      source: {
        type: 'geojson',
        data: data,
      },
      layout: {},
      paint: {
        'fill-color': '#088',
        'fill-opacity': 0.3,
      },
    })
    this.map.addLayer({
      id: 'buffer-range-line',
      type: 'line',
      source: {
        type: 'geojson',
        data: data,
      },
      layout: {},
      paint: {
        'line-color': '#088',
        'line-width': 2,
        'line-opacity': 0.8,
      },
    })
  }

  //定位(根据坐标)
  flyTo(options) {
    this.map.flyTo(options)
  }

  //根据范围定位
  fitBounds(bbox) {
    this.map.fitBounds(bbox, {
      padding: 40,
    })
  }

  // 显示图层
  showLayer(id) {
    this.map.setLayoutProperty(id, 'visibility', 'visible')
  }

  // 隐藏图层
  hideLayer(id) {
    this.map.setLayoutProperty(id, 'visibility', 'none')
  }
}

const _map_service2 = new MapService2()
export let MapService = mapService
export default _map_service2
